document.addEventListener("DOMContentLoaded", function(event) {
  function slider(){
    if (window.matchMedia("(max-width: 1023px)").matches) {
      var swiper = new Swiper('.benefits__swiper', {
        slidesPerView: 2,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
          breakpoints: {
          320: {
            slidesPerView: 1
          },
          769: {
            slidesPerView: 2
          }
        }
      });
    }
  }
  slider();

  if(document.querySelector('.testimonials__slider-text')){
      $('.testimonials__slider-text').slick({
        infinite: true,
        fade: true,
        loop: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 1300,
          settings: {
            fade: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            fade: false,
            dots: true,
            asNavFor: '.testimonials__slider-photo',
          }
        }
      ]
      });
      $('.testimonials__slider-photo').slick({
        infinite: true,
        loop: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '25%',
        asNavFor: '.testimonials__slider-text',
        nextArrow: $('.testimonials__arrow-box'),
        responsive: [
        {
          breakpoint: 1300,
          settings: {
            centerMode: false,
            centerPadding: '50px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '50px',
          }
        }
      ]
      });
    
  }

  if(document.querySelector('.reviews22__slider')){
      if (window.matchMedia("(min-width: 769px)").matches) {
              document.querySelectorAll('.reviews22__slide').forEach(function(elem,index){
          document.querySelector('.reviews22__slider').innerHTML +=  '<div class="reviews22__slide">' + elem.innerHTML + '</div>'; 
        });
      };

      $('.reviews22__slider').slick({
        infinite: true,
        loop: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '13%',
        responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
      });

  }

  document.querySelectorAll('.scoop__item').forEach(function(elem,index){
    if(index == 0){
      elem.classList.add('active');
    }
    elem.setAttribute('index',index);
    elem.addEventListener('click',function(elem,index){
      document.querySelector('.scoop__mob-tab-wrapper').classList.remove('hide');
     document.querySelectorAll('.scoop__item, .scoop__info-box').forEach(function(elem,index){
       elem.classList.remove('active');
     });
      this.classList.add('active');
      
      let mainIndex = this.getAttribute('index');
      document.querySelectorAll('.scoop__mot-item').forEach(function(elem,index){
        elem.classList.remove('active');
        if(mainIndex == index){
          elem.classList.add('active');
        }
      });
    });
  });

  document.querySelectorAll('.scoop__info-inner').forEach(function(elem,index){
    document.querySelector('.scoop__mob-tab').innerHTML += '<div class="scoop__mot-item">' + elem.innerHTML + '</div>'; 
  });
  
  document.querySelectorAll('.scoop__mot-item').forEach(function(elem,index){
    if(index == 0){
      elem.classList.add('active');
    }
  });

  if(document.querySelector('.mob-tab-wrapper__button')){
  document.querySelector('.mob-tab-wrapper__button').addEventListener('click',function(){
    document.querySelectorAll('.scoop__item').forEach(function(elem,index){
      elem.classList.remove('active');
    });
    document.querySelectorAll('.scoop__mot-item').forEach(function(elem,index){
      elem.classList.remove('active');
    });
    document.querySelector('.scoop__mob-tab-wrapper').classList.add('hide');
  });
  }

  
if(document.querySelector('.offer-subscription__products')){
  var firstSpan = document.querySelector('.offer-subscription__span1');
  var secondSpan = document.querySelector('.offer-subscription__span2');
  document.querySelectorAll('.offer-subscription__item').forEach(function(elem,index){
      if(firstSpan){
        firstSpan.classList.add('active');
      };
      if(index <= 2){
        elem.classList.add('show');
      }
  });

  if(document.querySelector('.offer-subscription__toggle-btn')){
  document.querySelector('.offer-subscription__toggle-btn').addEventListener('click',function(){
    if(!this.classList.contains('active')){
      firstSpan.classList.remove('active');
      secondSpan.classList.add('active');
      this.classList.add('active');
      document.querySelectorAll('.offer-subscription__item').forEach(function(elem,index){
        if(index > 2){
          elem.classList.add('show');
        };
        if(index <= 2){
          elem.classList.remove('show');
        }
      });
    }else{
      this.classList.remove('active');
      firstSpan.classList.add('active');
      secondSpan.classList.remove('active');
      document.querySelectorAll('.offer-subscription__item').forEach(function(elem,index){
        if(index > 2){
          elem.classList.remove('show');
        };
        if(index <= 2){
          elem.classList.add('show');
        }
      });
    }
    
  });
  }
    }
  
});
